import React, { createRef, useRef } from "react";
import { Formik } from "formik";
import { useParams, useLocation } from "react-router";

import { fetchAssetValues } from "../../utils/asset";
import { useAssets } from "../../contexts/assets";
import FormPage from "./FormPage";
import RemoteAssetSync from "../../components/RemoteAssetSync";
import useAuth from "../../hooks/useAuth";

export const formRef = createRef();

export default function Form({ overrideDisplayFields }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const warehouseDropdownEnabled = settings.warehouse_id_dropdown_menu;
  const { currentAsset } = useAssets();
  const { clientId } = useParams();
  const { pathname } = useLocation();
  const pathSegments = pathname.split("/");
  const isClientsRoute = pathSegments[1] === "clients";
  const displayClient = !warehouseDropdownEnabled && isClientsRoute && clientId === "null";
  const displayProject = isClientsRoute;
  const displayWarehouse = warehouseDropdownEnabled;
  // Per-field baseline ({ assetId, values }) shared with RemoteAssetSync and the
  // save path so a remote subscription update can't wipe unsaved edits.
  const baselineRef = useRef(null);

  return (
    <Formik
      key={currentAsset?.id}
      initialValues={fetchAssetValues(currentAsset)}
      onSubmit={() => {}}
      innerRef={formRef}
    >
      <>
        <RemoteAssetSync asset={currentAsset} baselineRef={baselineRef} />
        <FormPage
          type="capture"
          baselineRef={baselineRef}
          displayClient={displayClient}
          displayProject={displayProject}
          displayWarehouse={displayWarehouse}
          overrideDisplayFields={overrideDisplayFields}
        />
      </>
    </Formik>
  );
}
